import PropTypes from 'prop-types';
import { memo } from 'react';
import clsx from 'clsx';
import Navbar from './Navbar';
import Searchbar from './Searchbar';
import Topbar from './Topbar';

const Header = ({
  doShowNavbar,
  doShowSearchbar,
  doHaveSearchFormBgColor,
  textColorClass,
  bgColorClass,
  tabTextColorClass,
  filterBgColor,
}) => (
  <>
    {doShowNavbar && <Topbar />}
    <div className={clsx(bgColorClass, { 'font-body': doShowNavbar })}>
      <div
        className={clsx('container mx-auto', {
          'bg-searchForm-0 bg-opacity-25 p-8 rounded-3xl': doHaveSearchFormBgColor,
          'px-2 sm:px-0': !doHaveSearchFormBgColor,
          'pb-8': doShowSearchbar,
        })}
      >
        <div className={`${textColorClass}`}>{doShowNavbar && <Navbar />}</div>
        {doShowSearchbar && (
          <Searchbar textColorClass={tabTextColorClass} filterBgColor={filterBgColor} />
        )}
      </div>
    </div>
  </>
);

Header.propTypes = {
  doShowNavbar: PropTypes.bool,
  doShowSearchbar: PropTypes.bool,
  doHaveSearchFormBgColor: PropTypes.bool,
  textColorClass: PropTypes.string,
  bgColorClass: PropTypes.string,
  tabTextColorClass: PropTypes.string,
  filterBgColor: PropTypes.string,
};

Header.defaultProps = {
  doShowNavbar: true,
  doShowSearchbar: true,
  doHaveSearchFormBgColor: false,
  textColorClass: 'text-header-0',
  bgColorClass: 'bg-header',
  tabTextColorClass: undefined,
  filterBgColor: undefined,
};
export default memo(Header);
